import './polyfill';
// public-path must be imported before router
import '../public-path';

import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';

import { createBrowserHistory } from 'history';
import configureStore from 'store';

import { ApiClientProvider } from '@travel/api-client';
import { setReactUpgradeMonitoring } from '@travel/tracker'; //TODO: remove this when we finish React 19 migration
import { RpCookieProvider } from '@travel/traveler-core/contexts';
import UIComponentContext from '@travel/ui/contexts';

import { getSsrDeviceType } from 'store/userAgent/selectors';

import { createApiClient } from 'core/httpClient';
import commonErrorHandler from 'core/httpClient/commonErrorHandler';
import requestInterceptor from 'core/httpClient/requestInterceptor';
import responseInterceptor from 'core/httpClient/responseInterceptor';
import universalRouter from 'core/universalRouter';
import ClientRouter from 'core/universalRouter/client/Router';
import { Link } from 'core/universalRouter/Link';

setReactUpgradeMonitoring(); //TODO: remove this when we finish React 19 migration
const apiClient = createApiClient();

const history = createBrowserHistory({
  basename: window.PRELOADED_STATE.router.baseUrl,
});
const store = configureStore(window.PRELOADED_STATE, history, undefined, undefined, apiClient);
const ssrDeviceType = getSsrDeviceType(store.getState());

// Allow the passed state to be garbage-collected
delete window.PRELOADED_STATE;
if (window.EXPERIMENT_ASSIGNMENTS) {
  delete window.EXPERIMENT_ASSIGNMENTS;
}

apiClient.setRequestInterceptor(requestInterceptor(store));
apiClient.setResponseInterceptor(responseInterceptor(store));
apiClient.setCommonErrorHandler(commonErrorHandler(store));

(async () => {
  // For matching html from SSR
  const router = universalRouter({ store });

  const children = await router.resolve({
    ...history.location,
    skipResolver: true,
  });
  hydrateRoot(
    document.getElementById('root') as HTMLElement,
    <HelmetProvider>
      <UIComponentContext.Provider
        value={{
          ssrDeviceType: ssrDeviceType,
          LinkComponent: ({ href, children, ...rest }) => (
            <Link to={href || ''} {...rest}>
              {children}
            </Link>
          ),
        }}
      >
        <ApiClientProvider apiClient={apiClient}>
          <ReduxProvider store={store}>
            <RpCookieProvider>
              <ClientRouter history={history} router={router}>
                {children}
              </ClientRouter>
            </RpCookieProvider>
          </ReduxProvider>
        </ApiClientProvider>
      </UIComponentContext.Provider>
    </HelmetProvider>,
    {
      onRecoverableError: (error: any, errorInfo) => {
        console.warn({
          error,
          cause: error.cause,
          componentStack: errorInfo.componentStack,
          errorInfo,
        });
      },
    },
  );
})();
